import React, { useState } from "react";
import { MdKeyboardArrowDown } from "react-icons/md";
import { RxCross2 } from "react-icons/rx";
import { Link, NavLink } from "react-router-dom";
import { MdCall, MdEmail } from "react-icons/md";
import { RiMenu3Fill } from "react-icons/ri";

function Navbar() {
  const [isActive, setIsActive] = useState(true); // true means menu is closed (hamburger icon visible)
  const [activeSubmenu, setActiveSubmenu] = useState(null);

  const toggle = () => {
    setActiveSubmenu(null);
    if (window.innerWidth <= 769) {
      setTimeout(() => {
        const navItems = document.getElementById("NavItems");
        if (navItems) {
          navItems.classList.remove("menu-open");
          navItems.classList.add("menu-close");
          setTimeout(() => {
            navItems.style.display = "none";
            setIsActive(true);
          }, 400);
        }
        document.querySelector("body").classList.remove("transparent-body");
      }, 200);
    }
  };

  const gotoTop = () => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  };

  const handleSubmenuEnter = (name) => {
    if (window.innerWidth > 769) {
      setActiveSubmenu(name);
    }
  };

  const handleSubmenuLeave = () => {
    if (window.innerWidth > 769) {
      setActiveSubmenu(null);
    }
  };

  const handleSubmenuToggle = (name) => {
    if (window.innerWidth <= 769) {
      setActiveSubmenu(activeSubmenu === name ? null : name);
    }
  };

  return (
    <>
      <header>
        <div className="Header">
          <div className="HeaderLeft">
            <div className="vbulogo">
              <Link to="/" onClick={gotoTop}>
                <img src="/Images/vbu_logo.png" alt="vbulogo" />
              </Link>
            </div>
            <div className="HeaderName">
              <h1>University Department of Computer Applications</h1>
              <p>Vinoba Bhave University, Hazaribagh <b> (AICTE Approved) </b></p>
              <h5>Intake - 60</h5>
            </div>
            <div className="Menu">
              <span>
                {isActive ? (
                  <RiMenu3Fill
                    size="28px"
                    onClick={() => {
                      document.querySelector("#NavItems").style.display = "flex";
                      document.querySelector("#NavItems").style.backdropFilter = "grayscale(100%)";
                      setIsActive(false);
                      document.querySelector("body").classList.add("transparent-body");

                      setTimeout(() => {
                        document.getElementById("NavItems").classList.remove("menu-close");
                        document.getElementById("NavItems").classList.add("menu-open");
                      }, 100);
                    }}
                  />
                ) : (
                  <RxCross2
                    size="28px"
                    onClick={() => {
                      document.querySelector("body").classList.remove("transparent-body");
                      document.getElementById("NavItems").classList.remove("menu-open");
                      document.getElementById("NavItems").classList.add("menu-close");
                      setTimeout(() => {
                        document.querySelector("#NavItems").style.display = "none";
                        setIsActive(true);
                        setActiveSubmenu(null);
                      }, 400);
                    }}
                  />
                )}
              </span>
            </div>
          </div>
          <div className="HeaderRight">
            <div className="email-id">
              <div>
                <MdEmail className="header-icon" />
              </div>
              <Link to="mailto:vbumca@gmail.com">
                <div className="email-id-desc">
                  <span>Email</span>
                  <span>vbumca@gmail.com</span>
                </div>
              </Link>
            </div>
            <div
              className="login-btn"
              onClick={() => {
                window.open("https://console.vbumca.in", "_blank");
              }}
            >
              <input type="button" value="Login" name="login" />
            </div>
          </div>
        </div>
      </header>
      <nav id="nav">
        <div className="" id="navbar">
          <div className="NavbarContainer">
            <ul id="NavItems" className="menu-close">
              <NavLink
                to="/"
                onClick={() => {
                  gotoTop();
                  toggle();
                }}
              >
                <li>
                  <span>Home</span>
                </li>
              </NavLink>

              <li 
                onMouseOver={() => handleSubmenuEnter("Program")} 
                onMouseOut={handleSubmenuLeave}
                onClick={() => handleSubmenuToggle("Program")}
              >
                <div className="NavItem">
                  <span>Program</span>
                  <span className="downArrow">
                    <MdKeyboardArrowDown style={{ transform: activeSubmenu === "Program" ? "rotate(180deg)" : "rotate(0deg)", transition: "0.3s" }} />
                  </span>
                </div>

                <div className="NavSubItems" style={{ display: activeSubmenu === "Program" ? "flex" : "none" }}>
                  <ul className="NavProgram">
                    <NavLink to="/BCA" onClick={() => { gotoTop(); toggle(); }}><li>BCA</li></NavLink>
                    <NavLink to="/MCA" onClick={() => { gotoTop(); toggle(); }}><li>MCA</li></NavLink>
                  </ul>
                </div>
              </li>

              <li 
                onMouseOver={() => handleSubmenuEnter("Campus")} 
                onMouseOut={handleSubmenuLeave}
                onClick={() => handleSubmenuToggle("Campus")}
              >
                <div className="NavItem">
                  <span>Campus</span>
                  <span className="downArrow">
                    <MdKeyboardArrowDown style={{ transform: activeSubmenu === "Campus" ? "rotate(180deg)" : "rotate(0deg)", transition: "0.3s" }} />
                  </span>
                </div>

                <div className="NavSubItems" style={{ display: activeSubmenu === "Campus" ? "flex" : "none" }}>
                  <ul className="NavCampus MegaMenu">
                    <div className="MegaMenuSection">
                      <h4 className="MegaMenuHeading">Facilities</h4>
                      <div className="MegaMenuLinks">
                        <NavLink to="/library" onClick={() => { gotoTop(); toggle(); }}><li>Library</li></NavLink>
                        <NavLink to="/centralLibrary" onClick={() => { gotoTop(); toggle(); }}><li>Central Library</li></NavLink>
                        <NavLink to="/ground" onClick={() => { gotoTop(); toggle(); }}><li>Play Ground</li></NavLink>
                        <NavLink to="/auditorium" onClick={() => { gotoTop(); toggle(); }}><li>Vivekanand Sabhagar</li></NavLink>
                        <NavLink to="/solarPower" onClick={() => { gotoTop(); toggle(); }}><li>Solar Power Campus</li></NavLink>
                        <NavLink to="/park" onClick={() => { gotoTop(); toggle(); }}><li>Park</li></NavLink>
                        <NavLink to="/seminarHall" onClick={() => { gotoTop(); toggle(); }}><li>Seminar Hall</li></NavLink>
                        <NavLink to="/canteen" onClick={() => { gotoTop(); toggle(); }}><li>Cafeteria</li></NavLink>
                        <NavLink to="/atmAndBanks" onClick={() => { gotoTop(); toggle(); }}><li>ATM & Banks</li></NavLink>
                        <NavLink to="/computerCenter" onClick={() => { gotoTop(); toggle(); }}><li>Computer Center</li></NavLink>
                        <NavLink to="/insurance" onClick={() => { gotoTop(); toggle(); }}><li>Students and Faculty Insurance</li></NavLink>
                      </div>
                    </div>
                    <div className="MegaMenuSection">
                      <h4 className="MegaMenuHeading">Co-Curricular</h4>
                      <div className="MegaMenuLinks">
                        <NavLink to="/sports" onClick={() => { gotoTop(); toggle(); }}><li>Sports</li></NavLink>
                        <NavLink to="/ncc" onClick={() => { gotoTop(); toggle(); }}><li>NCC</li></NavLink>
                        <NavLink to="/nss" onClick={() => { gotoTop(); toggle(); }}><li>NSS</li></NavLink>
                        <NavLink to="/ncdrc" onClick={() => { gotoTop(); toggle(); }}><li>NCDRC</li></NavLink>
                        <NavLink to="/uba" onClick={() => { gotoTop(); toggle(); }}><li>UBA</li></NavLink>
                        <NavLink to="/womenEmpowerment" onClick={() => { gotoTop(); toggle(); }}><li>Women Empowerment Cell</li></NavLink>
                        <NavLink to="/inductionProgram" onClick={() => { gotoTop(); toggle(); }}><li>Induction Program</li></NavLink>
                      </div>
                    </div>
                  </ul>
                </div>
              </li>

              <NavLink
                to="/research"
                onClick={() => {
                  gotoTop();
                  toggle();
                }}
              >
                <li>
                  <span>Research</span>
                </li>
              </NavLink>

              <li 
                onMouseOver={() => handleSubmenuEnter("Resources")} 
                onMouseOut={handleSubmenuLeave}
                onClick={() => handleSubmenuToggle("Resources")}
              >
                <div className="NavItem">
                  <span>Resources</span>
                  <span className="downArrow">
                    <MdKeyboardArrowDown style={{ transform: activeSubmenu === "Resources" ? "rotate(180deg)" : "rotate(0deg)", transition: "0.3s" }} />
                  </span>
                </div>

                <div className="NavSubItems" style={{ display: activeSubmenu === "Resources" ? "flex" : "none" }}>
                  <ul className="NavResources">
                    <NavLink to="/libraryBooks" onClick={() => { gotoTop(); toggle(); }}><li>Library Books</li></NavLink>
                    <NavLink to="/labSoftware" onClick={() => { gotoTop(); toggle(); }}><li>Lab Software</li></NavLink>
                  </ul>
                </div>
              </li>

              <li 
                onMouseOver={() => handleSubmenuEnter("Administration")} 
                onMouseOut={handleSubmenuLeave}
                onClick={() => handleSubmenuToggle("Administration")}
              >
                <div className="NavItem">
                  <span>Administration</span>
                  <span className="downArrow">
                    <MdKeyboardArrowDown style={{ transform: activeSubmenu === "Administration" ? "rotate(180deg)" : "rotate(0deg)", transition: "0.3s" }} />
                  </span>
                </div>

                <div className="NavSubItems" style={{ display: activeSubmenu === "Administration" ? "flex" : "none" }}>
                  <ul className="NavAdministration">
                    <NavLink to="/directorMessage" onClick={() => { gotoTop(); toggle(); }}><li>Director Message</li></NavLink>
                    <NavLink to="/teachingMembers" onClick={() => { gotoTop(); toggle(); }}><li>Teaching Staff</li></NavLink>
                    <NavLink to="/nonTeachingMembers" onClick={() => { gotoTop(); toggle(); }}><li>Non Teaching Staff</li></NavLink>
                  </ul>
                </div>
              </li>

              <li 
                onMouseOver={() => handleSubmenuEnter("Alumni")} 
                onMouseOut={handleSubmenuLeave}
                onClick={() => handleSubmenuToggle("Alumni")}
              >
                <div className="NavItem">
                  <span>Alumni</span>
                  <span className="downArrow">
                    <MdKeyboardArrowDown style={{ transform: activeSubmenu === "Alumni" ? "rotate(180deg)" : "rotate(0deg)", transition: "0.3s" }} />
                  </span>
                </div>

                <div className="NavSubItems" style={{ display: activeSubmenu === "Alumni" ? "flex" : "none" }}>
                  <ul className="NavAlumni">
                    <NavLink to="/AlumniList" onClick={() => { gotoTop(); toggle(); }}><li>Alumni List</li></NavLink>
                    <NavLink to="/alumniForm" onClick={() => { gotoTop(); toggle(); }}><li>Alumni Form</li></NavLink>
                  </ul>
                </div>
              </li>

              <NavLink
                to="/gallery"
                onClick={() => {
                  gotoTop();
                  toggle();
                }}
              >
                <li>
                  <span> Gallery </span>
                </li>
              </NavLink>

              <li 
                onMouseOver={() => handleSubmenuEnter("Admission")} 
                onMouseOut={handleSubmenuLeave}
                onClick={() => handleSubmenuToggle("Admission")}
              >
                <div className="NavItem">
                  <span>Admission</span>
                  <span className="downArrow">
                    <MdKeyboardArrowDown style={{ transform: activeSubmenu === "Admission" ? "rotate(180deg)" : "rotate(0deg)", transition: "0.3s" }} />
                  </span>
                </div>

                <div className="NavSubItems" style={{ display: activeSubmenu === "Admission" ? "flex" : "none" }}>
                  <ul className="NavAdmission">
                    <NavLink to="/admissionProcess" onClick={() => { gotoTop(); toggle(); }}><li>Process</li></NavLink>
                    <NavLink to="/feeStructure" onClick={() => { gotoTop(); toggle(); }}><li>Fee Structure</li></NavLink>
                  </ul>
                </div>
              </li>

              <li 
                onMouseOver={() => handleSubmenuEnter("About")} 
                onMouseOut={handleSubmenuLeave}
                onClick={() => handleSubmenuToggle("About")}
              >
                <div className="NavItem">
                  <span>About</span>
                  <span className="downArrow">
                    <MdKeyboardArrowDown style={{ transform: activeSubmenu === "About" ? "rotate(180deg)" : "rotate(0deg)", transition: "0.3s" }} />
                  </span>
                </div>

                <div className="NavSubItems" style={{ display: activeSubmenu === "About" ? "flex" : "none" }}>
                  <ul className="NavAbout">
                    <NavLink to="/about" onClick={() => { gotoTop(); toggle(); }}><li>About Us</li></NavLink>
                    <NavLink to="/committee" onClick={() => { gotoTop(); toggle(); }}><li>Committees</li></NavLink>
                    <NavLink to="/aicteCommittees" onClick={() => { gotoTop(); toggle(); }}><li>AICTE Statutory Committees</li></NavLink>
                    <NavLink to="/eoa" onClick={() => { gotoTop(); toggle(); }}><li>Extension of Approval</li></NavLink>
                    <NavLink to="/mandatoryDisclosures" onClick={() => { gotoTop(); toggle(); }}><li>Mandatory Disclosures</li></NavLink>
                    <NavLink to="/clubAndCell" onClick={() => { gotoTop(); toggle(); }}><li>Club & Cell</li></NavLink>
                  </ul>
                </div>
              </li>

              <NavLink
                to="/contact"
                onClick={() => {
                  gotoTop();
                  toggle();
                }}
              >
                <li>
                  <span>Contact</span>
                </li>
              </NavLink>

              <li 
                onMouseOver={() => handleSubmenuEnter("More")} 
                onMouseOut={handleSubmenuLeave}
                onClick={() => handleSubmenuToggle("More")}
              >
                <div className="NavItem">
                  <span>More</span>
                  <span className="downArrow">
                    <MdKeyboardArrowDown style={{ transform: activeSubmenu === "More" ? "rotate(180deg)" : "rotate(0deg)", transition: "0.3s" }} />
                  </span>
                </div>

                <div className="NavSubItems" style={{ display: activeSubmenu === "More" ? "flex" : "none" }}>
                  <ul className="NavMore">
                    <NavLink to="/complaint" onClick={() => { gotoTop(); toggle(); }}><li>Complaint</li></NavLink>
                    <NavLink to="/feeSubmission" onClick={() => { gotoTop(); toggle(); }}><li>Online Fee Payment </li></NavLink>
                    <NavLink to="/feedback" onClick={() => { gotoTop(); toggle(); }}><li>Feedback</li></NavLink>
                    <NavLink to="/grievance" onClick={() => { gotoTop(); toggle(); }}><li>Grievance Redressal</li></NavLink>
                    <NavLink to="/quickLinks" onClick={() => { gotoTop(); toggle(); }}><li>Quick Links</li></NavLink>
                  </ul>
                </div>
              </li>

              <div
                className="login-btn-mobile"
                onClick={() => {
                  window.open("https://console.vbumca.in", "_blank");
                }}
              >
                <input type="button" value="Login" name="login" />
              </div>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}

export default Navbar;
